import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-home-smile-line",
    title: "Daire Temizliği",
    desc: "Evinizi hijyenik, düzenli ve ferah hale getiren profesyonel daire temizliği hizmeti.",
    path: "/hizmetlerimiz/daire-temizligi",
  },
  {
    icon: "ri-building-line",
    title: "Bina ve Site Temizliği",
    desc: "Apartman ve site ortak alanlarında düzenli, planlı ve hijyen odaklı temizlik.",
    path: "/hizmetlerimiz/bina-ve-site-temizligi",
  },
  {
    icon: "ri-building-4-line",
    title: "Apartman Temizliği",
    desc: "Merdiven, giriş, lobi ve ortak kullanım alanlarında periyodik temizlik.",
    path: "/hizmetlerimiz/apartman-temizligi",
  },
  {
    icon: "ri-hammer-line",
    title: "İnşaat Sonrası Temizlik",
    desc: "Tadilat ve inşaat sonrası detaylı temizlik ile kullanıma hazır alanlar.",
    path: "/hizmetlerimiz/insaat-sonrasi-temizlik",
  },
  {
    icon: "ri-sofa-line",
    title: "Koltuk Yıkama",
    desc: "Derinlemesine yıkama ile koltuklarınızı daha hijyenik ve ferah hale getiriyoruz.",
    path: "/hizmetlerimiz/koltuk-yikama",
  },
  {
    icon: "ri-rainbow-line",
    title: "Halı Yıkama",
    desc: "Halı yapısına uygun temizlik süreciyle hijyenik ve temiz sonuçlar.",
    path: "/hizmetlerimiz/hali-yikama",
  },
  {
    icon: "ri-t-shirt-line",
    title: "Kuru Temizleme ve Ütü",
    desc: "Kıyafetleriniz için özenli kuru temizleme ve düzenli ütü hizmeti.",
    path: "/hizmetlerimiz/kuru-temizleme-ve-utu",
  },
  {
    icon: "ri-bug-line",
    title: "İlaçlama",
    desc: "Ev, apartman, site ve iş yerlerinde profesyonel haşere ve böcek ilaçlama.",
    path: "/hizmetlerimiz/ilaclama",
  },
  {
    icon: "ri-briefcase-line",
    title: "Ofis ve İş Yeri Temizliği",
    desc: "Çalışan verimliliğini artıran düzenli ofis ve iş yeri temizlik çözümleri.",
    path: "/hizmetlerimiz/ofis-ve-is-yeri-temizligi",
  },
];

export default function ServiceCardsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1.5 rounded-full mb-3">
            Hizmetlerimiz
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Adana'da ihtiyacınıza uygun temizlik çözümleri
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Day Temizlik Adana, yaşam alanlarınızda hijyen, düzen ve konforu bir araya getiren profesyonel temizlik çözümleri sunar.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {services.map((service, index) => (
            <div
              key={service.path}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-50 rounded-lg mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${service.icon} w-6 h-6 flex items-center justify-center text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                {service.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {service.desc}
              </p>
              <Link
                to={service.path}
                className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
              >
                Detaylı incele
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}